// Campus photo for /colleges/university-of-california-irvine: CC BY-SA 3.0, by David Eppstein, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASciencePlaza.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-irvine/; credited under the photo.
const photo = {
    "slug": "university-of-california-irvine",
    "alt": "Rowland Hall and Reines Hall on the science plaza at UC Irvine in Irvine, California",
    "src": "/colleges/university-of-california-irvine/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-irvine/campus-800.webp",
    "srcMid": "/colleges/university-of-california-irvine/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-irvine/og.jpg",
    "title": "SciencePlaza",
    "author": "David Eppstein",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASciencePlaza.jpg",
    "read": "2026-09-30"
};

export default photo;
